// SPDX-License-Identifier: FSL-1.1-Apache-2.0
/**
 * @module AnalyticsDashboard
 * @package @geenius/analytics/react
 * @description Publishes the React analytics dashboard through the component
 * catalog while delegating rendering to the page implementation.
 */

import type React from "react";
import {
  AnalyticsDashboardPage,
  type AnalyticsDashboardPageProps,
} from "../pages/AnalyticsDashboardPage";

/** Props accepted by the public React analytics dashboard component. */
export type AnalyticsDashboardProps = AnalyticsDashboardPageProps;

/**
 * Renders the canonical React analytics dashboard as a component export.
 *
 * @param props Dashboard data, realtime state, and page composition options.
 * @returns The React analytics dashboard surface.
 */
export function AnalyticsDashboard(
  props: AnalyticsDashboardProps,
): React.ReactElement {
  return <AnalyticsDashboardPage {...props} />;
}
